export default __webpack_public_path__ + "static/media/neonjs.c9410845.svg";